__turbopack_context__.v({
  "headerSearchPopover": "Header-module__QFUA7W__headerSearchPopover",
  "headline": "Header-module__QFUA7W__headline",
  "hero": "Header-module__QFUA7W__hero",
  "heroContainer": "Header-module__QFUA7W__heroContainer",
  "heroImage": "Header-module__QFUA7W__heroImage",
  "heroMedia": "Header-module__QFUA7W__heroMedia",
  "input": "Header-module__QFUA7W__input",
  "inputWrap": "Header-module__QFUA7W__inputWrap",
  "searchButtonActivity": "Header-module__QFUA7W__searchButtonActivity",
  "searchButtonSpin": "Header-module__QFUA7W__searchButtonSpin",
  "searchButtonSpinner": "Header-module__QFUA7W__searchButtonSpinner",
  "searchCard": "Header-module__QFUA7W__searchCard",
  "searchIcon": "Header-module__QFUA7W__searchIcon",
  "searchRow": "Header-module__QFUA7W__searchRow",
  "smartBtn": "Header-module__QFUA7W__smartBtn",
  "spacer": "Header-module__QFUA7W__spacer",
  "widgetWrap": "Header-module__QFUA7W__widgetWrap",
});
